import React from 'react';
import { AvatarPreview, StatusBadge, NeoButton } from '../../components/Common';
import { MEMBER_STATUS } from "../../constants/members";

// Lista de abas de filtro para a página de clientes
export const MEMBER_STATUS_TABS = [
    { label: 'Todos', value: 'all' },
    { label: 'Ativos', value: MEMBER_STATUS.ACTIVE },
    { label: 'Prospect', value: MEMBER_STATUS.LEAD },
    { label: 'Inativos', value: MEMBER_STATUS.INACTIVE },
    { label: 'Suspensos', value: MEMBER_STATUS.SUSPENDED },
];

/**
 * Retorna as colunas da tabela de clientes
 * @param {function} navigate Função de navegação (react-router-dom)
 * @returns {Array} Array de configuração de colunas para o DataTable
 */
export const getMembersColumns = (navigate) => [
    {
        key: 'fullName',
        label: 'Nome / ID / E-mail',
        flex: '3',
        minWidth: 220,
        render: (row) => (
            <div className="neo-table-contact-cell">
                <AvatarPreview
                    src={row.photoUrl}
                    alt={row.fullName}
                    size="xs"
                    className="rounded-circle shadow-sm flex-shrink-0"
                    fallbackType="icon"
                />
                <div className="neo-table-contact-info">
                    <span className="neo-table-contact-name fw-bold text-dark font-size-14">
                        {row.fullName}
                    </span>
                    <div className="neo-table-contact-meta">
                        <small className="text-primary fw-bold font-size-10">ID: {row.memberNumber || "----"}</small>
                        <small className="text-muted font-size-11">{row.email || "Sem e-mail"}</small>
                    </div>
                </div>
            </div>
        )
    },
    {
        key: 'phone',
        label: 'Telefone',
        width: '150px',
        render: (row) => (
            <span className="text-muted font-size-13">
                <i className="mdi mdi-phone-outline me-1 text-primary"></i>
                {row.phone || "(00) 00000-0000"}
            </span>
        )
    },
    {
        key: "activities",
        label: "Atividades",
        flex: '1.5',
        minWidth: 120,
        render: (row) => (
            <div className="d-flex flex-wrap gap-1">
                {row.activityNames && row.activityNames.length > 0 ? (
                    row.activityNames.slice(0, 2).map((name, idx) => (
                        <span key={idx} className="badge bg-light text-dark border font-size-10 px-2 py-1">
                            {name}
                        </span>
                    ))
                ) : (
                    <small className="text-muted fst-italic">Nenhuma</small>
                )}
                {row.activityNames?.length > 2 && (
                    <span className="badge bg-light text-primary border font-size-10">+{row.activityNames.length - 2}</span>
                )}
            </div>
        )
    },
    {
        key: 'status',
        label: 'Status',
        flex: '1',
        minWidth: 100,
        align: 'center',
        render: (row) => <StatusBadge status={row.status} />
    },
    {
        key: 'actions',
        overflow: 'visible',
        label: '',
        width: '52px',
        align: 'center',
        render: (row) => (
            <NeoButton
                variant="soft-primary"
                size="sm"
                square
                icon="mdi-eye-outline"
                onClick={(e) => { e.stopPropagation(); navigate(`/members/${row.id}`); }}
                title="Ver Perfil"
            />
        )
    }
];
